import {CONST} from './Tooltip.constants';
import style from './style.module.scss';
const POINTER_SIZE = 20;
/**
 * function to calculate the startpoint x,y cordinate
 * of the tooltip
 */
export function calculateTooltipPosition(tooltipNode) {
  let wordPhrase = tooltipNode.parentNode;
  let wordRect = wordPhrase.getBoundingClientRect();
  let tooltipRect = tooltipNode.getBoundingClientRect();

  const switchCaseString = makeSwitchCaseString([
    displayOnTop(wordRect, wordPhrase),
    displayOnRight(wordRect),
    displayOnBottom(wordRect, wordPhrase),
    displayOnLeft(wordRect),
  ]);
  switch (switchCaseString) {
    case 'TOP_LEFT':
      return {
        position: calculateTopLeft(wordRect, tooltipRect),
        classList: [style.bottom, style.allignArrowRight],
      };
    case 'TOP_RIGHT':
      return {
        position: calculateTopRight(wordRect, tooltipRect),
        classList: [style.bottom],
      };
    case 'BOTTOM_LEFT':
      return {
        position: calculateBottomLeft(wordRect, tooltipRect),
        classList: [style.top, style.allignArrowRight],
      };
    case 'BOTTOM_RIGHT':
      return {position: calculateRightBottom(wordRect), classList: [style.top]};
    default:
      return {position: calculateRightBottom(wordRect), classList: [style.top]};
  }
}

function displayOnTop(wordRect, ref) {
  let page = getScrollParent(ref);
  let scrollOffset = page.scrollTop;
  return (wordRect.y + scrollOffset) - (CONST.MAX_HEIGHT_OFFSET + wordRect.height) > 0;
}

function displayOnRight(wordRect) {
  const vw = getViewportWidth();
  return vw - wordRect.x - (CONST.MAX_WIDTH_OFFSET + wordRect.width) > 0;
}

function displayOnBottom(wordRect, ref) {
  let page = getScrollParent(ref);
  let scrollOffset = page.scrollTop;
  const vh = page.scrollHeight;
  return vh - (wordRect.y + scrollOffset) - (CONST.MAX_HEIGHT_OFFSET + wordRect.height) > 0;
}

function displayOnLeft(wordRect) {
  return wordRect.x - (CONST.MAX_WIDTH_OFFSET + wordRect.width) > 0;
}

function getViewportWidth() {
  return Math.max(
    document.documentElement.clientWidth ?? 0,
    window.innerWidth ?? 0
  );
}

function getScrollParent(node) {
  if (node == null) {
    return null;
  }

  if (node.scrollHeight > node.clientHeight) {
    return node;
  } else {
    return getScrollParent(node.parentNode);
  }
}

function getViewportHeight() {
  return Math.max(
    document.documentElement.clientHeight ?? 0,
    window.innerHeight ?? 0
  );
}

function makeSwitchCaseString(position) {
  let caseList = [];
  if (position[2]) {
    caseList.push('BOTTOM');
  }
  else{
    caseList.push('TOP');
  }
  if (position[3]) {
    caseList.push('LEFT');
  }
  else{
    caseList.push('RIGHT');
  }
  return caseList.join('_');
}

function calculateRightBottom(wordRect) {
  let quarterOfWordWidth = wordRect.width * 0.5;
  return {
    left: `${wordRect.x + quarterOfWordWidth}px`,
    top: `${wordRect.y + POINTER_SIZE + wordRect.height}px`,
  };
}

function calculateBottomLeft(wordRect, tooltipRect) {
  let quarterOfWordWidth = wordRect.width * 0.5;
  return {
    left: `${wordRect.x + quarterOfWordWidth - tooltipRect.width}px`,
    top: `${wordRect.y + POINTER_SIZE + wordRect.height}px`,
  };
}

function calculateTopRight(wordRect, tooltipRect) {
  let quarterOfWordWidth = wordRect.width * 0.5;
  return {
    left: `${wordRect.x + quarterOfWordWidth}px`,
    top: `${wordRect.y - (POINTER_SIZE + tooltipRect.height)}px`,
  };
}

function calculateTopLeft(wordRect, tooltipRect) {
  let quarterOfWordWidth = wordRect.width * 0.5;
  return {
    left: `${wordRect.x + quarterOfWordWidth - tooltipRect.width}px`,
    top: `${wordRect.y - (POINTER_SIZE + tooltipRect.height)}px`,
  };
}

/**
 * Function to fetch the nearest scrolling ancestor of the
 * an element
 */

export function getNearestScrollingAncestor(node) {
  if (node === null) {
    return document;
  } else {
    if (node.scrollHeight > node.clientHeight) {
      return node;
    } else {
      return getNearestScrollingAncestor(node.parentNode);
    }
  }
}
